<template>
  <div id="installapp">
    <h1>Install App</h1>
    <!-- <v-btn class="ma-2" outlined color="teal" @click="tabeRe()">
      <v-icon>mdi-flash</v-icon>Refresh
    </v-btn>-->
    <v-app id="inspire">
      <v-card>
        <v-card-title>
          Install Apps
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="myitems" :search="search" sort-field="durations"></v-data-table>
      </v-card>
    </v-app>
  </div>
</template>
<style scoped>
</style>
<script>
import { applist } from "../../firebaseConfig";
export default {
  name: "Installapp",
  data() {
    return {
      search: "",
      myitems: [],
      headers: [
        {
          text: "App name",
          align: "start",
          sortable: false,
          value: "appname"
        },
        { text: "Package Name", value: "pname" },
        { text: "Version Code", value: "versionCode" },
        { text: "Version Name", value: "versionName" }
      ],
      desserts: [
        {
          deviceID: "Frozen Yogurt",
          durations: 159,
          name: 6.0,
          carbs: 24,
          number: 4.0,
          time: "1%"
        }
      ]
    };
  },
  mounted: function() {
    this.tabeRe();
  },
  methods: {
    async myD() {
      return applist
        .child("78KOHWXhC0UTR3fxqkqsoJ7j1Ew1")
        .child("357422072109932")
        .on("value", snapshot => {
          this.myitems = snapshot.val();
        });
    },
    async tabeRe() {
     await this.myD();
    }
  }
};
</script>